import React from "react";
import { useTranslation } from "react-i18next";

import { setLocale } from "../i18n";
import { track } from "../lib/analytics";

export default function LanguageSwitcher() {
    const { i18n } = useTranslation();
    const current = (i18n.resolvedLanguage || i18n.language || "en").slice(0, 2);

    const switchTo = (next) => () => {
        if (next === current) return;
        track("locale_change", { from: current, to: next });
        setLocale(next);
    };

    const Pill = ({ code, label }) => (
        <button
            type="button"
            onClick={switchTo(code)}
            data-testid={`locale-${code}`}
            aria-pressed={current === code}
            style={{
                background: "transparent",
                border: "none",
                padding: 0,
                cursor: "pointer",
                fontFamily: "'JetBrains Mono', monospace",
                fontSize: "0.7rem",
                letterSpacing: "0.12em",
                textTransform: "uppercase",
                color: current === code ? "var(--ink)" : "var(--muted)",
                fontWeight: current === code ? 500 : 400,
                borderBottom:
                    current === code ? "1px solid var(--accent)" : "1px solid transparent",
                paddingBottom: "2px",
                transition: "color 0.2s, border-color 0.2s",
            }}
        >
            {label}
        </button>
    );

    return (
        <div
            className="locale-switcher"
            data-testid="locale-switcher"
            role="group"
            aria-label="Language"
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "0.5rem",
            }}
        >
            <Pill code="en" label="EN" />
            <span style={{ color: "var(--muted)", fontFamily: "'JetBrains Mono', monospace", fontSize: "0.7rem" }}>·</span>
            <Pill code="es" label="ES" />
        </div>
    );
}
